<template>
  <div style="height: 100%; width: 100%">
    <div class="map-wrap">
      <!-- 左侧统计信息框 -->
      <div class="top-box">
        <div class="content">
          <div style="position: absolute; width: 100%; height: 100%; left: 0; top: 0; overflow: hidden">
            <p class="shan"></p>
          </div>

          <div class="side-text left">
            <div>
              <img src="../../assets/icon-line.png" class="icon-line mr-20" />
              <span>湖南长沙</span>
              <img src="../../assets/icon-line.png" class="icon-line ml-20" />
            </div>
            <div>
              <img class="bg-head-Left element1 animated flash2" src="../../assets/bg-head-Left-one.png" />
              <img class="bg-head-Left element2 animated flash2" src="../../assets/bg-head-Left-one.png" />
              <img class="bg-head-Left element3 animated flash2" src="../../assets/bg-head-Left-two.png" />
            </div>
          </div>
          <div class="big-title">统建统服概览</div>
          <!--font-style  -->
          <div class="side-text right">
            <div>
              <img class="bg-head-Right element3 animated flash2" src="../../assets/bg-head-Left-two.png" />
              <img class="bg-head-Right element2 animated flash2" src="../../assets/bg-head-Left-one.png" />
              <img class="bg-head-Right element1 animated flash2" src="../../assets/bg-head-Left-one.png" />
            </div>
            <div>
              <img src="../../assets/icon-line.png" class="icon-line mr-20" />
              <span>{{ timeStr }}</span>
              <img src="../../assets/icon-line.png" class="icon-line ml-20" />
            </div>
          </div>
        </div>
      </div>
      <div style="height: 92%; width: 100%; display: flex; flex-direction: row; justify-content: space-between">
        <div class="left-box">
          <!-- 分区1：充电总览 -->
          <div style="width: 100%">
            <div class="flex flex-j-s flex-a-c flex-row title">
              <div class="charging-header">充电总览</div>
              <!-- <div class="flex flex-j-s flex-row flex-a-c "
                style="border: #165dff 2px solid; border-radius: 5px;padding: 4px 3px 4px 8px; background-color: #183883;">
                <div style="color:#fff;font-size: 14px;">导出</div>
                <img style="width: 15px;height: 15px;padding-left: 2px;" src="../../assets/导出.png" />
              </div> -->
            </div>
            <div class="all-box">
              <div class="charging-stats">
                <div style="display: flex; flex-direction: column; justify-content: space-around">
                  <div class="stat-row">
                    <div style="display: flex; flex-direction: row; align-items: center">
                      <img src="../../assets/订单.png" style="width: 20px; height: 20px" />
                      <span>当日订单数</span>
                      <span style="font-size: 10px; color: #1df9fc">(单)</span>
                    </div>
                    <span class="stat-value">156 </span>
                  </div>
                  <hr class="hr_h" />
                  <div class="stat-row">
                    <div style="display: flex; flex-direction: row; align-items: center">
                      <img src="../../assets/营业.png" style="width: 20px; height: 20px" />
                      <span>营业额</span>
                      <span style="font-size: 10px; color: #1df9fc">(元)</span>
                    </div>
                    <span class="stat-value">3,675 </span>
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; justify-content: space-between">
                  <hr class="hr_w" />
                  <hr class="hr_w" />
                </div>
                <div style="display: flex; flex-direction: column; justify-content: space-around">
                  <div class="stat-row">
                    <div style="display: flex; flex-direction: row; align-items: center">
                      <img src="../../assets/电量.png" style="width: 20px; height: 20px" />
                      <span>电量</span>
                      <span style="font-size: 10px; color: #1df9fc">(kWh)</span>
                    </div>
                    <span class="stat-value">2,450 </span>
                  </div>
                  <hr class="hr_h" />
                  <div class="stat-row">
                    <div style="display: flex; flex-direction: row; align-items: center">
                      <img src="../../assets/利润.png" style="width: 20px; height: 20px" />
                      <span>利润额</span>
                      <span style="font-size: 10px; color: #1df9fc">(元)</span>
                    </div>
                    <span class="stat-value">1,837 </span>
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; justify-content: space-between">
                  <hr class="hr_w" />
                  <hr class="hr_w" />
                </div>
                <div style="display: flex; flex-direction: column; justify-content: space-around">
                  <div class="stat-row">
                    <div style="display: flex; flex-direction: row; align-items: center">
                      <img src="../../assets/电量.png" style="width: 20px; height: 20px" />
                      <span>电量</span>
                      <span style="font-size: 10px; color: #1df9fc">(kWh)</span>
                    </div>
                    <span class="stat-value">2,450 </span>
                  </div>
                  <hr class="hr_h" />
                  <div class="stat-row">
                    <div style="display: flex; flex-direction: row; align-items: center">
                      <img src="../../assets/利润.png" style="width: 20px; height: 20px" />
                      <span>利润额</span>
                      <span style="font-size: 10px; color: #1df9fc">(元)</span>
                    </div>
                    <span class="stat-value">1,837 </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 分区2：日充电情况统计分析 -->
          <div style="width: 100%">
            <div class="flex flex-j-s flex-a-c flex-row title">
              <div class="charging-header">充电情况统计</div>
              <div class="time-filter">
                <el-radio-group v-model="timeRange" size="mini" @change="handleTimeRangeChange">
                  <el-radio-button label="日">日</el-radio-button>
                  <el-radio-button label="月">月</el-radio-button>
                  <el-radio-button label="年">年</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div class="all-box">
              <!-- 时间筛选器 -->
              <div class="time-filter" style="margin-bottom: 10px">
                <!-- 时间筛选器已在title中显示 -->
              </div>
              <!-- ECharts曲线图容器 -->
              <div id="chargingTrendChart" ref="chargingTrendChart" style="width: 100%; height: 100%"></div>
            </div>
          </div>

          <!-- 分区3：趋势分析 -->
          <div style="width: 100%">
            <div class="flex flex-j-s flex-a-c flex-row title">
              <div class="charging-header">趋势分析</div>
              <!-- <div class="flex flex-j-s flex-row flex-a-c "
                style="border: #165dff 2px solid; border-radius: 5px;padding: 4px 3px 4px 8px; background-color: #183883;">
                <div style="color:#fff;font-size: 14px;">导出</div>
                <img style="width: 15px;height: 15px;padding-left: 2px;" src="../../assets/导出.png" />
              </div> -->
            </div>

            <div class="all-box">
              <!-- ECharts柱状图容器 -->
              <div id="trendBarChart" ref="trendBarChart" style="width: 100%; height: 100%"></div>
            </div>
          </div>
        </div>

        <!-- 右侧功能按钮 -->
        <div class="right-box">
          <!-- 分区5：用户详细信息 -->
          <div style="width: 100%">
            <div class="flex flex-j-s flex-a-c flex-row title">
              <div class="charging-header">用户详细信息</div>
              <!-- <div class="flex flex-j-s flex-row flex-a-c "
                style="border: #165dff 2px solid; border-radius: 5px;padding: 4px 3px 4px 8px; background-color: #183883;">
                <div style="color:#fff;font-size: 14px;">导出</div>
                <img style="width: 15px;height: 15px;padding-left: 2px;" src="../../assets/导出.png" />
              </div> -->
            </div>
            <div class="all-box">
              <!-- 自动滚动容器 -->
              <div class="user-list-scroll" ref="userScroll" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
                <div class="user-scroll-content" :style="{ transform: `translateY(-${scrollPosition}px)` }">
                  <!-- 扩展用户数据 -->
                  <div class="user-item" v-for="(user, index) in extendedUserList" :key="index">
                    <div class="user-info">
                      <span class="user-name">{{ user.name }}</span>
                      <span class="user-phone">{{ user.phone }}</span>
                      <span class="user-address">{{ user.address }}</span>
                      <span class="user-charge">{{ user.chargeTime }}</span>
                    </div>
                    <!-- <el-tag size="mini" :type="getStatusType(user.status)">{{ user.statusText }}</el-tag> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 分区6：高级统计 -->
          <div style="width: 100%">
            <div class="flex flex-j-s flex-a-c flex-row title">
              <div class="charging-header">高级统计</div>
            </div>
            <div class="all-box">
              <div class="advanced-stats">
                <div style="width: 48%; display: flex; flex-direction: column; justify-content: space-between">
                  <div class="advanced-item">
                    <div>充电效率</div>
                    <div class="advanced-font">85%</div>
                  </div>
                  <div class="advanced-item">
                    <div>设备利用率</div>
                    <div class="advanced-font">72%</div>
                  </div>
                  <div class="advanced-item">
                    <div>用户满意度</div>
                    <div class="advanced-font">92%</div>
                  </div>
                </div>
                <!-- <div class="advanced-item">
                <div>故障率</div>
                <div>3.5%</div>
              </div> -->
                <div style="width: 48%; display: flex; flex-direction: column; justify-content: space-between">
                  <div class="advanced-item">
                    <div>总充电时长</div>
                    <div class="advanced-font">1,560 小时</div>
                  </div>
                  <div class="advanced-item">
                    <div>平均充电时长</div>
                    <div class="advanced-font">45 分钟</div>
                  </div>
                  <div class="advanced-item">
                    <div>峰时充电占比</div>
                    <div class="advanced-font">68%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 分区4：台区接入信息 -->
          <div style="width: 100%">
            <div class="flex flex-j-s flex-a-c flex-row title">
              <div class="charging-header">台区接入信息</div>
            </div>
            <div class="all-box">
              <!-- ECharts饼状图容器 -->
              <div id="accessPieChart" ref="accessPieChart" style="width: 100%; height: 100%"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- ECharts 地图容器 -->
      <div id="echartsMap" ref="echartsMap"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts"
import hunan from "../home/utils/hunan.json"
import pageMixin from "@/mixins/pageMixin.js"
import { GetAllPowerTransformer } from "@/api/dev_arch_powersite"

export default {
  mixins: [pageMixin],
  data() {
    return {
      timeStr: "",
      chart: null,
      chargingTrendChart: null,
      trendBarChart: null,
      accessPieChart: null,
      edgesubstationOnlineCount: 0,
      edgesubstationfaultCount: 0,
      edgesubstationCount: 0,
      faultIndicatorOnlineCount: 0,
      faultIndicatorfaultCount: 0,
      faultIndicatorCount: 0,
      soeCount: 0,
      tabName: "",
      filter: { keywords: "" },
      lines: [],
      dialogTableVisible: false,
      showFault: false,
      tableData: [],
      soeinfoid: [],
      soeinfocount: 0,
      eventdata: [],
      eventtotal: 0,
      eventpage: 1,
      eventlimit: 7,
      showdevicelsdialog: false,
      devicelstab: [],
      status: 0,
      devtype: 0,
      loading: false,
      faulttabdata: [],
      faultcount: 0,
      devList: [],
      mapCenter: [112.983, 28.183],
      cityData: [],
      mockData: {
        devices: [],
        soeList: [],
        faultList: [],
        linePaths: {},
        events: [],
        lineTree: []
      },

      // 新增充电数据相关变量
      timeRange: "日",
      trendDate: [new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), new Date()],
      selectedArea: "area1",
      accessDateRange: [new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), new Date()],

      // 用户信息滚动相关
      scrollPosition: 0,
      scrollSpeed: 0.1, // 滚动速度（像素/帧）
      scrollInterval: null,
      isPaused: false,

      // 扩展用户列表
      extendedUserList: [
        { name: "张三", phone: "13800138001", address: "长沙市岳麓区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "李四", phone: "13800138002", address: "长沙市开福区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "王五", phone: "13800138003", address: "长沙市天心区", chargeTime: "2026-04-29 15:44:33", status: 2, statusText: "欠费" },
        { name: "赵六", phone: "13800138004", address: "长沙市雨花区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "钱七", phone: "13800138005", address: "株洲市天元区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "孙八", phone: "13800138006", address: "湘潭市岳塘区", chargeTime: "2026-04-29 15:44:33", status: 3, statusText: "停用" },
        { name: "周九", phone: "13800138007", address: "长沙市芙蓉区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "吴十", phone: "13800138008", address: "长沙市望城区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "郑十一", phone: "13800138009", address: "长沙市长沙县", chargeTime: "2026-04-29 15:44:33", status: 2, statusText: "欠费" },
        { name: "王十二", phone: "13800138010", address: "长沙市宁乡市", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "李十三", phone: "13800138011", address: "长沙市浏阳市", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "张十四", phone: "13800138012", address: "长沙市岳麓区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "刘十五", phone: "13800138013", address: "长沙市开福区", chargeTime: "2026-04-29 15:44:33", status: 3, statusText: "停用" },
        { name: "陈十六", phone: "13800138014", address: "长沙市天心区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "杨十七", phone: "13800138015", address: "长沙市雨花区", chargeTime: "2026-04-29 15:44:33", status: 2, statusText: "欠费" },
        { name: "黄十八", phone: "13800138016", address: "长沙市芙蓉区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "赵十九", phone: "13800138017", address: "衡阳市雁峰区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "周二十", phone: "13800138018", address: "郴州市北湖区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" },
        { name: "吴廿一", phone: "13800138019", address: "常德市武陵区", chargeTime: "2026-04-29 15:44:33", status: 3, statusText: "停用" },
        { name: "郑廿二", phone: "13800138020", address: "益阳市赫山区", chargeTime: "2026-04-29 15:44:33", status: 1, statusText: "正常" }
      ]
    }
  },
  created() {
    this.timer = setInterval(() => {
      this.getCurrentTime()
    }, 1000)

    // this.getLocalWeather();
    // // 每隔2h刷新天气接口
    // this.weatherTimer = setInterval(() => {
    //   this.getLocalWeather();
    // }, 2 * 60 * 60 * 1000);
  },
  mounted() {
    this.fetchRealDevices()
      .then(() => {
        this.initMockData()
        this.initEchartsMap()
        this.$nextTick(() => {
          this.initChargingTrendChart()
          this.initTrendBarChart()
          this.initAccessPieChart()
          // 初始化自动滚动
          this.initAutoScroll()
        })
      })
      .catch(() => {
        this.initMockData()
        this.initEchartsMap()
        this.$nextTick(() => {
          this.initChargingTrendChart()
          this.initTrendBarChart()
          this.initAccessPieChart()
          // 初始化自动滚动
          this.initAutoScroll()
        })
      })

    // 监听窗口大小变化，调整图表大小
    window.addEventListener("resize", this.handleResize)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    if (this.chargingTrendChart) {
      this.chargingTrendChart.dispose()
    }
    if (this.trendBarChart) {
      this.trendBarChart.dispose()
    }
    if (this.accessPieChart) {
      this.accessPieChart.dispose()
    }
    if (this.scrollInterval) {
      cancelAnimationFrame(this.scrollInterval)
    }
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    getCurrentTime() {
      let date = new Date()
      let year = date.getFullYear()
      let month = this.addZero(date.getMonth() + 1)
      let day = this.addZero(date.getDate())
      let hour = this.addZero(date.getHours())
      let minute = this.addZero(date.getMinutes())
      let second = this.addZero(date.getSeconds())
      let week = this.getWeek(date.getDay())
      let timeStr = year + "年" + month + "月" + day + "日 " + hour + ":" + minute + ":" + second + " " + week
      this.timeStr = timeStr
      // console.log(this.timeStr)
    },
    addZero(num) {
      return num < 10 ? "0" + num : num
    },
    getWeek(num) {
      let day = ""
      switch (num) {
        case 0:
          day = "星期天"
          break
        case 1:
          day = "星期一"
          break
        case 2:
          day = "星期二"
          break
        case 3:
          day = "星期三"
          break
        case 4:
          day = "星期四"
          break
        case 5:
          day = "星期五"
          break
        case 6:
          day = "星期六"
          break
      }
      return day
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
      if (this.chargingTrendChart) {
        this.chargingTrendChart.resize()
      }
      if (this.trendBarChart) {
        this.trendBarChart.resize()
      }
      if (this.accessPieChart) {
        this.accessPieChart.resize()
      }
    },

    // 初始化充电趋势曲线图
    initChargingTrendChart() {
      const chartDom = this.$refs.chargingTrendChart
      if (!chartDom) return

      this.chargingTrendChart = echarts.init(chartDom)

      // 模拟数据
      const mockData = {
        日: [120, 135, 150, 145, 160, 175, 156],
        月: [2450, 2300, 2600, 2400, 2550, 2500, 2650, 2700, 2800, 2750, 2600, 2450],
        年: [28000, 29500, 31000, 32000, 33500]
      }

      const xAxisData = {
        日: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
        月: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
        年: ["2022", "2023", "2024", "2025", "2026"]
      }

      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,0.7)",
          borderColor: "#165dff",
          textStyle: { color: "#fff" },
          formatter: (params) => {
            return `${params[0].name}<br/>总充电量: <span style="color:#1df9fc">${params[0].value} kWh</span>`
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "5%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: xAxisData[this.timeRange],
          axisLine: { lineStyle: { color: "rgba(255,255,255,0.3)" } },
          axisLabel: { color: "#fff" }
        },
        yAxis: {
          type: "value",
          name: "kWh",
          axisLine: { lineStyle: { color: "rgba(255,255,255,0.3)" } },
          axisLabel: { color: "#fff" },
          splitLine: { lineStyle: { color: "rgba(255,255,255,0.1)" } }
        },
        series: [
          {
            name: "总充电量",
            type: "line",
            smooth: true,
            data: mockData[this.timeRange],
            symbol: "circle",
            symbolSize: 6,
            lineStyle: {
              color: "#1df9fc",
              width: 3
            },
            itemStyle: {
              color: "#1df9fc",
              borderColor: "#fff",
              borderWidth: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(29, 249, 252, 0.4)" },
                { offset: 1, color: "rgba(29, 249, 252, 0.1)" }
              ])
            }
          }
        ]
      }

      this.chargingTrendChart.setOption(option)
    },

    // 时间范围变更处理
    handleTimeRangeChange() {
      this.initChargingTrendChart()
    },

    // 初始化趋势柱状图 - 修改X轴配置确保文字完整显示
    initTrendBarChart() {
      const chartDom = this.$refs.trendBarChart
      if (!chartDom) return

      this.trendBarChart = echarts.init(chartDom)

      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          backgroundColor: "rgba(0,0,0,0.7)",
          borderColor: "#165dff",
          textStyle: { color: "#fff" },
          formatter: (params) => {
            const data = params[0]
            let unit = ""
            if (data.name === "站点数") unit = "个"
            else if (data.name === "日订单数") unit = "单"
            else if (data.name === "日均电量") unit = "kWh"
            else if (data.name === "日均营业额") unit = "元"

            return `${data.name}: <span style="color:#1df9fc">${data.value} ${unit}</span>`
          }
        },
        grid: {
          left: "3%", // 增加左边距
          right: "3%", // 增加右边距
          bottom: "1%", // 增加底部边距
          top: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: ["站点数", "日订单数", "日均电量", "日均营业额"],
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.3)"
            }
          },
          axisLabel: {
            color: "#fff",
            // 关键修改：确保所有X轴文字完整显示
            interval: 0, // 强制显示所有标签
            rotate: 0, // 不旋转文字
            fontSize: 11, // 调整字体大小
            width: 60, // 设置标签宽度
            overflow: "break", // 文字超出时换行
            formatter: function (value) {
              // 确保文字不被截断
              return value
            }
          },
          // 调整X轴与容器边界的距离
          boundaryGap: true
        },
        yAxis: [
          {
            type: "value",
            name: "",
            axisLine: { lineStyle: { color: "rgba(255,255,255,0.3)" } },
            axisLabel: { color: "#fff" },
            splitLine: { lineStyle: { color: "rgba(255,255,255,0.1)" } }
          }
        ],
        series: [
          {
            name: "趋势数据",
            type: "bar",
            barWidth: "35%", // 调窄柱宽
            data: [
              {
                value: 28,
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#2d82ff" }, // 底部：更深蓝色
                    { offset: 0.4, color: "#1e6ae0" }, // 下部：深蓝色
                    { offset: 0.7, color: "#1652b5" }, // 上部：中蓝色
                    { offset: 1, color: "#0e3a8c" } // 顶部：浅蓝色
                  ])
                }
              },
              {
                value: 145,
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#2d82ff" }, // 底部：更深蓝色
                    { offset: 0.4, color: "#1e6ae0" }, // 下部：深蓝色
                    { offset: 0.7, color: "#1652b5" }, // 上部：中蓝色
                    { offset: 1, color: "#0e3a8c" } // 顶部：浅蓝色
                  ])
                }
              },
              {
                value: 2280,
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#2d82ff" }, // 底部：更深蓝色
                    { offset: 0.4, color: "#1e6ae0" }, // 下部：深蓝色
                    { offset: 0.7, color: "#1652b5" }, // 上部：中蓝色
                    { offset: 1, color: "#0e3a8c" } // 顶部：浅蓝色
                  ])
                }
              },
              {
                value: 3420,
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#2d82ff" }, // 底部：更深蓝色
                    { offset: 0.4, color: "#1e6ae0" }, // 下部：深蓝色
                    { offset: 0.7, color: "#1652b5" }, // 上部：中蓝色
                    { offset: 1, color: "#0e3a8c" } // 顶部：浅蓝色
                  ])
                }
              }
            ],
            label: {
              show: true,
              position: "top",
              color: "#fff",
              fontSize: 12
            }
          }
        ]
      }

      this.trendBarChart.setOption(option)
    },

    // 初始化台区接入饼状图
    initAccessPieChart() {
      const chartDom = this.$refs.accessPieChart
      if (!chartDom) return

      this.accessPieChart = echarts.init(chartDom)

      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0,0,0,0.7)",
          borderColor: "#165dff",
          textStyle: { color: "#fff" },
          formatter: "{a} <br/>{b}: {c} 户 ({d}%)"
        },
        legend: {
          orient: "vertical",
          right: 10,
          top: "center",
          textStyle: { color: "#fff" }
        },
        series: [
          {
            name: "台区接入情况",
            type: "pie",
            radius: ["40%", "80%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 7,
              borderColor: "#000d1f",
              borderWidth: 3
            },
            label: {
              show: false,
              position: "center",
              color: "#fff"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold",
                color: "#fff"
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 156, name: "已接入用户", itemStyle: { color: "#2d82ff" } },
              { value: 44, name: "可再接入", itemStyle: { color: "#00b42a" } },
              { value: 23, name: "新增用户", itemStyle: { color: "#ff7d00" } }
            ]
          }
        ]
      }

      this.accessPieChart.setOption(option)
    },

    // 初始化自动滚动
    initAutoScroll() {
      this.scrollInterval = requestAnimationFrame(this.scrollContent)
    },

    // 滚动内容
    scrollContent() {
      if (!this.isPaused) {
        this.scrollPosition += this.scrollSpeed

        // 获取内容容器
        const container = this.$refs.userScroll
        if (container) {
          const contentHeight = container.querySelector(".user-scroll-content").scrollHeight
          const containerHeight = container.clientHeight

          // 如果滚动到底部，重置位置
          if (this.scrollPosition >= contentHeight - containerHeight) {
            this.scrollPosition = 0
          }
        }
      }

      // 继续下一帧
      this.scrollInterval = requestAnimationFrame(this.scrollContent)
    },

    // 暂停滚动
    pauseScroll() {
      this.isPaused = true
    },

    // 恢复滚动
    resumeScroll() {
      this.isPaused = false
    },

    // 获取状态标签类型
    getStatusType(status) {
      switch (status) {
        case 1:
          return "success"
        case 2:
          return "warning"
        case 3:
          return "danger"
        default:
          return "info"
      }
    },

    // 原有的其他方法保持不变
    fetchRealDevices() {
      return GetAllPowerTransformer()
        .then((res) => {
          if (res.data) {
            const realDevices = res.data.map((item) => ({
              ID: item.ID,
              archive_parentname: "",
              archive_name: item.name,
              terminal_id: item.triplet_id,
              Manufacturer: "",
              terminal_name: "",
              device_status: 2,
              device_type: "边缘子站",
              device_model: "",
              is_operation: true,
              pointTable_type_name: "",
              heartbeat_time: item.modify_time || item.create_time,
              longitude: item.gps_lng || 113.014607,
              latitude: item.gps_lat || 28.193727,
              city: "长沙市",
              link_addr: "",
              name: item.name,
              line_name: "",
              devType: 1
            }))

            this.mockData.devices = realDevices
            this.devList = realDevices
            this.updateCityData()
            this.calcStatistics()
            return Promise.resolve()
          } else {
            return Promise.reject()
          }
        })
        .catch((err) => {
          console.error("获取变压器数据失败，使用模拟数据", err)
          return Promise.reject()
        })
    },

    updateCityData() {
      const cityCounts = {}
      this.mockData.devices.forEach((device) => {
        const city = device.city || "长沙市"
        cityCounts[city] = (cityCounts[city] || 0) + 1
      })

      this.cityData = Object.keys(cityCounts).map((city) => ({
        name: city,
        value: cityCounts[city]
      }))
    },

    initEchartsMap() {
      echarts.registerMap("hunan", hunan)

      const chartDom = this.$refs.echartsMap
      this.chart = echarts.init(chartDom)

      const dataList = this.cityData.length > 0 ? this.cityData : this.getDefaultCityData()

      const devicePoints = this.convertDevicesToPoints()

      const option = {
        backgroundColor: "transparent",
        title: {
          text: "",
          top: 20,
          left: 20,
          textStyle: {
            color: "#fff",
            fontSize: 18,
            fontWeight: "bold",
            textShadow: "0 0 5px rgba(0,0,0,0.5)"
          }
        },
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0,0,0,0.7)",
          borderColor: "#165dff",
          textStyle: {
            color: "#fff"
          },
          formatter: (params) => {
            if (params.componentType === "series") {
              if (params.seriesType === "scatter") {
                const device = params.data.device
                return `
                  <div style="font-weight: bold; margin-bottom: 8px; color: #165dff; font-size: 14px;">设备详细信息</div>
                  <div style="margin-bottom: 4px;"><span style="color: #ccc;">设备名称：</span>${device.archive_name}</div>
                  <div style="margin-bottom: 4px;"><span style="color: #ccc;">设备类型：</span>${device.device_type}</div>
                  <div style="margin-bottom: 4px;"><span style="color: #ccc;">设备状态：</span>${this.getDeviceStatusText(device.device_status)}</div>
                  <div style="margin-bottom: 4px;"><span style="color: #ccc;">位置：</span>${device.longitude.toFixed(6)}, ${device.latitude.toFixed(6)}</div>
                  <div style="margin-bottom: 4px;"><span style="color: #ccc;">最后上报：</span>${device.heartbeat_time || "未知"}</div>
                `
              } else if (params.seriesType === "map") {
                return `${params.name}<br/>设备数量：${params.value || 0}台`
              }
            }
            return params.name
          }
        },
        visualMap: {
          min: 0,
          max: 100,
          orient: "horizontal",
          type: "piecewise",
          left: "center",
          bottom: 40,
          textStyle: {
            color: "#fff",
            fontWeight: "bold",
            textShadow: "0 0 3px #000"
          },
          pieces: [
            { gte: 0, lt: 1, color: "rgba(136, 192, 255, 0.6)", label: "0" },
            { gte: 1, lt: 10, color: "rgba(93, 168, 252, 0.6)", label: "1-9" },
            { gte: 10, lt: 20, color: "rgba(37, 140, 255, 0.6)", label: "10-19" },
            { gte: 20, lt: 50, color: "rgba(17, 108, 209, 0.6)", label: "20-49" },
            { gte: 50, color: "rgba(9, 86, 173, 0.6)", label: "≥50" }
          ]
        },
        geo: {
          type: "map",
          map: "hunan",
          roam: true,
          zoom: 1,
          center: 0,
          label: {
            normal: {
              borderColor: "rgba(255, 255, 255, 0.8)",
              show: true,
              areaColor: "transparent",
              textStyle: {
                color: "#fff",
                fontSize: 12,
                fontWeight: "bold",
                textShadow: "0 0 3px #000"
              }
            },
            emphasis: {
              borderColor: "rgba(255, 255, 255, 0.8)",
              areaColor: "transparent",
              show: true,
              textStyle: {
                color: "#fff",
                fontWeight: "bold",
                textShadow: "0 0 5px #165dff"
              }
            }
          },
          itemStyle: {
            normal: {
              textStyle: {
                color: "#fff",
                fontSize: 13,
                fontWeight: "bold",
                textShadow: "0 0 3px #000"
              },
              areaColor: "transparent",
              borderColor: "rgba(255, 255, 255, 0.4)",
              borderWidth: 1
            },
            emphasis: {
              textStyle: {
                color: "#fff",
                fontSize: 13,
                fontWeight: "bold",
                textShadow: "0 0 3px #000"
              },
              areaColor: "transparent",
              borderColor: "rgba(255, 255, 255, 0.8)",
              borderWidth: 2
            }
          }
        },
        series: [
          {
            type: "map",
            map: "hunan",
            data: dataList,
            label: {
              normal: {
                show: true,
                formatter: "{b}",
                textStyle: {
                  color: "transparent",
                  fontSize: 13,
                  fontWeight: "bold",
                  textShadow: "0 0 3px #000"
                }
              },
              emphasis: {
                borderColor: "transparent",
                show: true,
                textStyle: {
                  color: "transparent",
                  fontSize: 13,
                  fontWeight: "bold",
                  textShadow: "0 0 5px #165dff"
                }
              }
            },
            itemStyle: {
              normal: {
                areaColor: "rgba(102, 149, 255, 0.05)",
                borderColor: "transparent",
                borderWidth: 1
              }
            },
            emphasis: {
              itemStyle: {
                areaColor: "rgba(22, 93, 255, 0.3)"
              }
            }
          },
          {
            name: "设备",
            type: "scatter",
            coordinateSystem: "geo",
            data: devicePoints,
            symbolSize: 18,
            symbol: "circle",
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: true,
                formatter: (params) => {
                  return params.data.device.archive_name
                },
                position: "top",
                textStyle: {
                  color: "#fff",
                  fontSize: 12,
                  fontWeight: "bold",
                  textShadow: "0 0 3px #000"
                }
              }
            },
            itemStyle: {
              normal: {
                color: (params) => {
                  const device = params.data.device
                  switch (device.device_status) {
                    case 1:
                      return "#8f8f8f"
                    case 2:
                      return "#165dff"
                    case 3:
                      return "#f56c6c"
                    default:
                      return "#8f8f8f"
                  }
                },
                shadowBlur: 8,
                shadowColor: "rgba(0, 0, 0, 0.8)",
                borderColor: "#fff",
                borderWidth: 2
              },
              emphasis: {
                color: (params) => {
                  const device = params.data.device
                  switch (device.device_status) {
                    case 1:
                      return "#a0a0a0"
                    case 2:
                      return "#3a7cff"
                    case 3:
                      return "#ff7878"
                    default:
                      return "#a0a0a0"
                  }
                },
                shadowBlur: 12,
                shadowColor: "rgba(0, 0, 0, 0.5)",
                borderColor: "#fff",
                borderWidth: 3
              }
            }
          }
        ]
      }

      this.chart.setOption(option)

      this.chart.on("click", (params) => {
        if (params.componentType === "series" && params.seriesType === "scatter") {
          const device = params.data.device
          this.showDeviceInfo(device)
        }
      })
    },

    convertDevicesToPoints() {
      return this.devList.map((device) => ({
        name: device.archive_name,
        value: [device.longitude, device.latitude],
        device: device
      }))
    },

    getDefaultCityData() {
      return [
        { name: "长沙市", value: 0 },
        { name: "株洲市", value: 0 },
        { name: "湘潭市", value: 0 },
        { name: "岳阳市", value: 0 },
        { name: "益阳市", value: 0 },
        { name: "常德市", value: 0 },
        { name: "张家界市", value: 0 },
        { name: "湘西土家族苗族自治州", value: 0 },
        { name: "怀化市", value: 0 },
        { name: "娄底市", value: 0 },
        { name: "邵阳市", value: 0 },
        { name: "永州市", value: 0 },
        { name: "衡阳市", value: 0 },
        { name: "郴州市", value: 0 }
      ]
    },

    showDeviceInfo(device) {
      this.$alert(
        `
        <div style="text-align: left; line-height: 1.6;">
          <div style="margin-bottom: 8px; font-size: 16px; font-weight: bold; color: #165dff;">设备详细信息</div>
          <div style="margin-bottom: 6px;"><strong>设备名称：</strong>${device.archive_name}</div>
          <div style="margin-bottom: 6px;"><strong>设备类型：</strong>${device.device_type}</div>
          <div style="margin-bottom: 6px;"><strong>设备状态：</strong><span style="color: ${this.getStatusColor(device.device_status)}">${this.getDeviceStatusText(device.device_status)}</span></div>
          <div style="margin-bottom: 6px;"><strong>终端ID：</strong>${device.terminal_id || "N/A"}</div>
          <div style="margin-bottom: 6px;"><strong>经纬度：</strong>${device.longitude.toFixed(6)}, ${device.latitude.toFixed(6)}</div>
          <div style="margin-bottom: 6px;"><strong>最后心跳：</strong>${device.heartbeat_time || "N/A"}</div>
          <div style="margin-bottom: 6px;"><strong>所属线路：</strong>${device.archive_parentname || "N/A"}</div>
        </div>
      `,
        "设备详情",
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          confirmButtonText: "确定",
          closeOnPressEscape: true,
          customClass: "device-info-dialog"
        }
      )
    },

    getStatusColor(status) {
      switch (status) {
        case 1:
          return "#8f8f8f"
        case 2:
          return "#165dff"
        case 3:
          return "#f56c6c"
        default:
          return "#8f8f8f"
      }
    },

    handleSearchDev() {
      if (!this.filter.keywords.trim()) {
        this.updateMapWithDevices(this.devList)
        this.$message.info("已显示所有设备")
        return
      }

      const keyword = this.filter.keywords.toLowerCase()
      const filtered = this.devList.filter(
        (device) =>
          (device.archive_name && device.archive_name.toLowerCase().includes(keyword)) ||
          (device.link_addr && device.link_addr.toLowerCase().includes(keyword)) ||
          (device.line_name && device.line_name.toLowerCase().includes(keyword)) ||
          (device.terminal_id && device.terminal_id.toLowerCase().includes(keyword))
      )

      if (filtered.length > 0) {
        this.updateMapWithDevices(filtered)

        if (filtered.length === 1) {
          const device = filtered[0]
          this.chart.setOption({
            geo: {
              center: [device.longitude, device.latitude],
              zoom: 12
            }
          })
        } else {
          const lngs = filtered.map((d) => d.longitude)
          const lats = filtered.map((d) => d.latitude)
          const centerLng = (Math.min(...lngs) + Math.max(...lngs)) / 2
          const centerLat = (Math.min(...lats) + Math.max(...lats)) / 2
          this.chart.setOption({
            geo: {
              center: [centerLng, centerLat],
              zoom: 9
            }
          })
        }

        this.$message.success(`找到 ${filtered.length} 个设备`)
      } else {
        this.$message.warning("未找到相关设备")
      }
    },

    updateMapWithDevices(devices) {
      const devicePoints = devices.map((device) => ({
        name: device.archive_name,
        value: [device.longitude, device.latitude],
        device: device
      }))

      this.chart.setOption({
        series: [
          {
            data: devicePoints
          }
        ]
      })
    },

    // 其他原有方法...
    // ...（保留原有的其他方法，如viewDetail、loadAllLineTree等）

    initMockData() {
      const devices = [
        {
          ID: 1,
          archive_parentname: "馈线A",
          archive_name: "故障指示器1",
          terminal_id: "T001",
          Manufacturer: "厂商X",
          terminal_name: "终端1",
          device_status: 2,
          device_type: "故障指示器",
          device_model: "HDJN2023",
          is_operation: true,
          pointTable_type_name: "类型1",
          heartbeat_time: "2023-08-04 09:55:59",
          longitude: 113.014607,
          latitude: 28.193727,
          city: "长沙市",
          link_addr: "192.168.1.101",
          name: "故障指示器1",
          line_name: "10kV测试线",
          devType: 2
        },
        {
          ID: 2,
          archive_parentname: "馈线B",
          archive_name: "边缘子站1",
          terminal_id: "T002",
          Manufacturer: "厂商Y",
          terminal_name: "终端2",
          device_status: 1,
          device_type: "边缘子站",
          device_model: "EB-2000",
          is_operation: false,
          pointTable_type_name: "类型2",
          heartbeat_time: "2023-08-03 10:22:10",
          longitude: 112.99898,
          latitude: 28.211993,
          city: "长沙市",
          link_addr: "192.168.1.102",
          name: "边缘子站1",
          line_name: "10kV测试线",
          devType: 1
        },
        {
          ID: 3,
          archive_parentname: "馈线A",
          archive_name: "故障指示器2",
          terminal_id: "T003",
          Manufacturer: "厂商X",
          terminal_name: "终端3",
          device_status: 3,
          device_type: "故障指示器",
          device_model: "HDJN2023",
          is_operation: true,
          pointTable_type_name: "类型1",
          heartbeat_time: "2023-08-04 14:30:00",
          longitude: 113.039921,
          latitude: 28.201948,
          city: "株洲市",
          link_addr: "192.168.1.103",
          name: "故障指示器2",
          line_name: "10kV测试线",
          devType: 2
        },
        {
          ID: 4,
          archive_parentname: "馈线C",
          archive_name: "边缘子站2",
          terminal_id: "T004",
          Manufacturer: "厂商Z",
          terminal_name: "终端4",
          device_status: 2,
          device_type: "边缘子站",
          device_model: "EB-3000",
          is_operation: true,
          pointTable_type_name: "类型3",
          heartbeat_time: "2023-08-04 16:20:45",
          longitude: 113.050736,
          latitude: 28.208151,
          city: "长沙市",
          link_addr: "192.168.1.104",
          name: "边缘子站2",
          line_name: "10kV测试线",
          devType: 1
        },
        {
          ID: 5,
          archive_parentname: "馈线B",
          archive_name: "故障指示器3",
          terminal_id: "T005",
          Manufacturer: "厂商X",
          terminal_name: "终端5",
          device_status: 1,
          device_type: "故障指示器",
          device_model: "HDJN2023",
          is_operation: false,
          pointTable_type_name: "类型1",
          heartbeat_time: "2023-08-02 08:12:33",
          longitude: 112.960195,
          latitude: 28.167605,
          city: "湘潭市",
          link_addr: "192.168.1.105",
          name: "故障指示器3",
          line_name: "10kV测试线",
          devType: 2
        }
      ]

      this.mockData.devices = devices
      this.devList = devices

      this.mockData.soeList = [
        { ID: 101, archive_name: "馈线A", alarmcontent: "过流Ⅰ段动作", is_confirm: false },
        { ID: 102, archive_name: "馈线B", alarmcontent: "接地告警", is_confirm: true },
        { ID: 103, archive_name: "馈线C", alarmcontent: "开关变位", is_confirm: false },
        { ID: 104, archive_name: "馈线A", alarmcontent: "重合闸成功", is_confirm: false }
      ]

      this.mockData.faultList = [
        {
          ID: 201,
          fault_time: "2023-08-04 09:30:22",
          substation_name: "变电站A",
          archive_name: "馈线A",
          fault_term: "A相",
          fault_result: "永久性故障",
          create_time: "2023-08-04 09:35:10"
        },
        {
          ID: 202,
          fault_time: "2023-08-04 14:20:15",
          substation_name: "变电站B",
          archive_name: "馈线B",
          fault_term: "B相",
          fault_result: "瞬时性故障",
          create_time: "2023-08-04 14:25:30"
        }
      ]

      this.mockData.events = [
        { ID: 301, eventdesc: "线路过负荷", event_time: "2023-08-04 08:30", archive_name: "馈线A", eventsection: "#1杆-#5杆" },
        { ID: 302, eventdesc: "接地故障", event_time: "2023-08-03 14:20", archive_name: "馈线B", eventsection: "#10杆-#15杆" },
        { ID: 303, eventdesc: "开关跳闸", event_time: "2023-08-02 22:15", archive_name: "馈线C", eventsection: "#20杆" },
        { ID: 304, eventdesc: "电压越限", event_time: "2023-08-01 11:05", archive_name: "馈线A", eventsection: "#2杆" },
        { ID: 305, eventdesc: "保护动作", event_time: "2023-07-31 19:40", archive_name: "馈线B", eventsection: "#12杆" },
        { ID: 306, eventdesc: "重合闸成功", event_time: "2023-07-30 06:30", archive_name: "馈线C", eventsection: "#22杆" },
        { ID: 307, eventdesc: "设备异常", event_time: "2023-07-29 13:10", archive_name: "馈线A", eventsection: "#7杆" }
      ]

      this.mockData.lineTree = [
        {
          ID: 1,
          name: "变电站A",
          showname: "变电站A",
          Children: [
            { ID: "line1", name: "10kV馈线A", showname: "10kV馈线A" },
            { ID: "line2", name: "10kV馈线B", showname: "10kV馈线B" }
          ]
        },
        {
          ID: 2,
          name: "变电站B",
          showname: "变电站B",
          Children: [
            { ID: "line3", name: "10kV馈线C", showname: "10kV馈线C" },
            { ID: "line4", name: "10kV馈线D", showname: "10kV馈线D" }
          ]
        }
      ]

      this.mockData.linePaths = {
        line1: [
          [113.014607, 28.193727],
          [112.99898, 28.211993],
          [113.039921, 28.201948]
        ],
        line2: [
          [113.050736, 28.208151],
          [112.960195, 28.167605],
          [112.962362, 28.195654]
        ],
        line3: [
          [113.014607, 28.193727],
          [113.02, 28.2],
          [113.03, 28.21]
        ],
        line4: [
          [112.99, 28.18],
          [112.98, 28.19],
          [112.97, 28.2]
        ]
      }

      this.calcStatistics()
      this.updateCityData()
    },

    calcStatistics() {
      const devices = this.mockData.devices
      this.edgesubstationCount = devices.filter((d) => d.devType === 1).length
      this.edgesubstationOnlineCount = devices.filter((d) => d.devType === 1 && d.device_status === 2).length
      this.edgesubstationfaultCount = devices.filter((d) => d.devType === 1 && d.device_status === 3).length
      this.faultIndicatorCount = devices.filter((d) => d.devType === 2).length
      this.faultIndicatorOnlineCount = devices.filter((d) => d.devType === 2 && d.device_status === 2).length
      this.faultIndicatorfaultCount = devices.filter((d) => d.devType === 2 && d.device_status === 3).length
      this.soeCount = this.mockData.soeList.length
    },

    getDeviceStatusText(num) {
      switch (num) {
        case 1:
          return this.$t("spread.offlinetit")
        case 2:
          return this.$t("spread.onlinetit")
        case 3:
          return this.$t("spread.faulttit")
        default:
          return ""
      }
    }
  }
}
</script>

<style scoped lang="scss">
.top-box {
  width: 100%;
}

.content {
  position: relative;
  width: 100%;
  height: 70px;
  // margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 23px;
  background: url(../../assets/bg-head.png) no-repeat;
  background-size: 100% 70px;
}

.big-title {
  color: #fff;
  text-align: center;
  font-size: 38px;
  font-weight: bold;
  text-shadow: 0 0 26px #01b6ea;
  letter-spacing: 10px;
}

.side-text {
  font-size: 15px;
  color: #1df9fc;
}

.icon-line {
  width: 24px;
  height: 16px;
}

.left {
  width: 35%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.right {
  width: 35%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.font-style {
  font-family: "DingTalk-JinBuTi", sans-serif;
}

.bg-head-Left {
  width: 45px;
  height: 45px;
}

.bg-head-Right {
  width: 45px;
  height: 45px;
  transform: scaleX(-1);
}

.time-filter .el-radio-group .el-radio-button {
  flex: 1;
}

.time-filter .el-radio-group .el-radio-button :deep(.el-radio-button__inner) {
  width: 100%;
  padding: 8px 12px;
  /* 移除背景色设置 */
  background-color: transparent;
  /* 改为透明 */
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.time-filter .el-radio-group .el-radio-button :deep(.el-radio-button__inner:hover) {
  /* 移除悬停背景色或设置为透明 */
  background-color: transparent;
  /* 或 rgba(22, 93, 255, 0.1) 如果需要轻微效果 */
}

.time-filter .el-radio-group .el-radio-button :deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  /* 移除选中状态的背景色 */
  background-color: #165dff;
  /* 或保留边框颜色 */
  border-color: #165dff;
  box-shadow: none;
  color: #fff;
  /* 可选：改变文字颜色以示选中状态 */
}

.map-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  /* 设置背景图片 - 请将路径替换为你的实际图片路径 */
  background-image: url("../../assets/background.jpg");
  /* 这里替换为你的背景图片路径 */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  /* 可选：固定背景 */
  display: flex;
  align-items: center;
  padding: 0 18px;
  justify-content: space-between;
  flex-direction: column;
}

#echartsMap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 20px;
  left: 0;
  z-index: 1;
  background: transparent;
  /* 确保ECharts容器透明 */
}

.title {
  padding-bottom: 8px;
  padding-top: 4px;
  background: url("../../assets/Title-other.png") no-repeat;
  background-size: 190px;
}

/* 调整覆盖组件的背景色以适应背景图片 */
.left-box {
  width: 30%;
  height: 100%;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  padding: 20px;
  justify-content: space-between;
  flex-direction: column;
}

.right-box {
  width: 30%;
  height: 100%;
  z-index: 2;
  align-items: flex-end;
  display: flex;
  padding: 20px;
  justify-content: space-between;
  flex-direction: column;
}

/* 分区 */
.all-box {
  width: 100%;
  height: 175px;
  display: flex;
  flex-direction: column;
  padding: 12px;
  backdrop-filter: blur(5px);
  background-color: #000b201f;
  background-size: 2px 10px, 10px 2px;
  border: 1px solid rgba(153, 204, 255, 0.25);
  box-shadow: 0px 0px 16px 0px rgba(153, 204, 255, 0.25);
  border-radius: 5px;
  overflow: hidden;
  /* 隐藏滚动条 */

  .user-list-scroll {
    flex: 1;
    height: 100%;
    overflow: hidden;
    position: relative;
    cursor: pointer;

    .user-scroll-content {
      position: absolute;
      width: 100%;
      transition: transform 0.1s linear;
    }

    .user-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
      border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
      font-size: 12px;
      color: #fff;
      transition: background-color 0.3s;

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 4px;
      }

      &:last-child {
        border-bottom: none;
      }

      .user-info {
        display: flex;
        align-items: center;
        flex: 1;
        gap: 10px;

        .user-name {
          width: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: bold;
        }

        .user-phone {
          width: 90px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: rgba(255, 255, 255, 0.8);
        }

        .user-address {
          flex: 1;
          min-width: 90px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: rgba(255, 255, 255, 0.7);
        }

        .user-charge {
          width: 120px;
          text-align: left;
          color: #1df9fc;
          font-weight: bold;
        }
      }

      .el-tag {
        transform: scale(0.8);
        min-width: 40px;
        text-align: center;
      }
    }
  }

  .advanced-stats {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 6px;
    overflow-y: auto;
    /* 隐藏滚动条但保留滚动功能 */
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */

    &::-webkit-scrollbar {
      display: none;
      /* Chrome, Safari, Opera */
    }

    .advanced-item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 14px;
      padding: 13px 8px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 4px;
      color: #fff;
      border-left: 3px solid #165dff;
    }

    .advanced-font {
      font-weight: 600;
      font-size: 15px;
      color: #1df9fc;
      font-family: "DingTalk-JinBuTi", sans-serif;
    }
  }
}

.charging-header {
  font-family: "DingTalk-JinBuTi", sans-serif;
  font-size: 16px;
  padding-left: 70px;
  height: 30px;
  line-height: 25px;
  font-weight: bold;
  color: #ffffff;
}

.charging-stats {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  gap: 6px;
  padding: 10px;

  .stat-row {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    color: #fff;

    .stat-value {
      font-weight: bold;
      color: #1df9fc;
      font-size: 22px;
      padding: 10px;
      font-family: "DingTalk-JinBuTi", sans-serif;
    }
  }
}

.hr_w {
  display: inline-block;
  width: 1px;
  padding: 0px;
  height: 60px;
  border-color: #233b7540;
  background-color: #233b7540;
  margin: 0 2px;
}

.hr_h {
  width: 100px;
  border-color: #233b7540;
  padding: 0px;
  margin-top: 5px;
  margin-bottom: 5px;
  /* height: 1px; */
  background-color: #233b7540;
}

/* 原有样式保持不变 */
.line-box {
  right: 60px;
  top: 20%;
  bottom: 20px;
  width: 280px;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 3;
  padding: 16px;
  overflow-y: auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(5px);
  /* 隐藏滚动条但保留滚动功能 */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .title {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
    color: #333;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;
  }

  .line-item {
    margin-bottom: 16px;
    padding: 10px;
    background: rgba(249, 249, 249, 0.8);
    border-radius: 6px;
    border-left: 3px solid #165dff;

    .site {
      font-weight: bold;
      color: #165dff;
      margin-bottom: 8px;
      font-size: 14px;
    }

    .lines {
      padding-left: 10px;

      .line {
        color: #333;
        margin-top: 8px;
        padding: 5px 10px;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        font-size: 13px;

        &:hover {
          background-color: rgba(230, 247, 255, 0.8);
          color: #165dff;
          transform: translateX(5px);
        }
      }
    }
  }
}

.event-box {
  width: 320px;
  background-color: rgba(255, 255, 255, 0.9);
  right: 60px;
  top: 20%;
  bottom: 20px;
  z-index: 3;
  padding: 16px;
  overflow-y: auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(5px);
  /* 隐藏滚动条但保留滚动功能 */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .title {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
    color: #333;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;
  }

  .event-item {
    position: relative;
    padding: 12px 0 12px 24px;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.1);

    &::before {
      content: "";
      width: 12px;
      height: 12px;
      background-color: #165dff;
      border-radius: 50%;
      left: 0;
      top: 16px;
      border: 3px solid #fff;
      box-shadow: 0 0 0 2px #165dff;
      z-index: 1;
    }

    &:not(:last-child)::after {
      content: "";
      border-left: 2px dashed #165dff;
      height: calc(100% - 12px);
      top: 28px;
      left: 5px;
      z-index: 0;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .content {
    font-size: 13px;
    color: #333;
    line-height: 1.5;

    div {
      margin-top: 5px;
    }
  }
}

.map_search_box {
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 300px;
  height: 80px;
  z-index: 2;

  .el-input {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-right: 10px;
  }

  .el-input-box {
    left: 10px;

    .el-icon-search {
      color: rgb(255, 255, 255);
      font-weight: bold;
      cursor: pointer;
    }
  }
}
</style>
